const scope = 'WorkspaceSwitcher/';
export const SET_LOADING_FLAG = `${scope}SET_LOADING_FLAG`;
export const GET_USER_WORKSPACES = `${scope}GET_USER_WORKSPACES`;
export const SET_USER_WORKSPACES = `${scope}SET_USER_WORKSPACES `;
export const SET_SELECTED_WORKSPACES = `${scope}SET_SELECTED_WORKSPACES `;
export const SET_IS_SEARCH = `${scope}SET_IS_SEARCH `;
